import secureLocalStorage from 'react-secure-storage';

export const SESSION_UPDATED_EVENT = 'invert:session-updated';

const ROLE_CONFIG = {
    admin: {
        flagKey: 'admin',
        tokenKey: 'adminToken',
        loginPath: '/adminLogin/',
        dashboardPath: '/adminDashboard/home',
    },
    advertiser: {
        flagKey: 'advertiser',
        tokenKey: 'advertiserToken',
        loginPath: '/advertiserLogin/',
        dashboardPath: '/advertiserDashboard/home',
    },
    user: {
        flagKey: 'user',
        tokenKey: 'userToken',
        loginPath: '/userLogin/',
        dashboardPath: '/user/compose',
    }
};

const notifySessionUpdated = () => {
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event(SESSION_UPDATED_EVENT));
    }
};

export const parseJwt = (token) => {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
};

export const getStoredRole = () => {
    if (localStorage.getItem('admin') === 'true') {
        return 'admin';
    }
    if (localStorage.getItem('advertiser') === 'true') {
        return 'advertiser';
    }
    if (localStorage.getItem('user') === 'true') {
        return 'user';
    }
    try {
        const raw = localStorage.getItem('userSession');
        if (raw) {
            const session = JSON.parse(raw);
            if (session?.token) {
                localStorage.setItem('user', 'true');
                localStorage.setItem('userToken', session.token);
                return 'user';
            }
        }
    } catch {
        // ignore malformed session
    }
    return null;
};

export const getRoleToken = (role) => {
    const config = ROLE_CONFIG[role];
    if (!config) {
        return null;
    }
    return localStorage.getItem(config.tokenKey);
};

export const getRoleLoginPath = (role) => {
    return ROLE_CONFIG[role]?.loginPath || '/';
};

export const getRoleDashboardPath = (role) => {
    return ROLE_CONFIG[role]?.dashboardPath || '/';
};

export const persistRoleSession = ({ role, token, refreshToken, name }) => {
    const config = ROLE_CONFIG[role];
    if (!config || !token) {
        return;
    }

    Object.entries(ROLE_CONFIG).forEach(([roleName, roleConfig]) => {
        if (roleName !== role) {
            localStorage.removeItem(roleConfig.flagKey);
            localStorage.removeItem(roleConfig.tokenKey);
        }
    });

    localStorage.setItem(config.flagKey, 'true');
    localStorage.setItem(config.tokenKey, token);
    secureLocalStorage.setItem('tk', token);

    if (refreshToken) {
        localStorage.setItem('refreshToken', refreshToken);
    }

    if (name) {
        localStorage.setItem('name', name);
    }

    notifySessionUpdated();
};

export const clearRoleSession = () => {
    Object.values(ROLE_CONFIG).forEach(({ flagKey, tokenKey }) => {
        localStorage.removeItem(flagKey);
        localStorage.removeItem(tokenKey);
    });

    localStorage.removeItem('refreshToken');
    localStorage.removeItem('name');
    secureLocalStorage.removeItem('tk');
    notifySessionUpdated();
};

export const getRefreshIdentifier = (refreshToken) => {
    const decodedRefreshToken = parseJwt(refreshToken);
    if (!decodedRefreshToken) {
        return null;
    }
    return decodedRefreshToken.phoneNumber || decodedRefreshToken.email || null;
};
